// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"94130dc5","239":"646fbf17"}[chunkId] + ".chunk.js";
};